module.exports = __webpack_public_path__ + "img/smile1.0.60ce210e.svg";